/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * The vx-table component.
 */
export class VxTable {
    constructor() {
        this.heading = undefined;
        this.columns = 2;
        this.headers = undefined;
        this.data = [];
    }
    /**
     * Split data into multiple tables for multi column display.
     */
    getSplitTableData() {
        if (this.columns <= 1)
            return [this.data];
        const batches = [];
        const columnSize = Math.ceil(this.data.length / this.columns);
        for (let i = 0; i < this.columns; i++) {
            batches.push(this.data.slice(columnSize * i, columnSize * i + columnSize));
        }
        return batches;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '18d8c12a4c3138277edef9436590e85c5b1e751c' }, h("div", { key: 'be546cc7df2c8fbe2251360f65259695be2e8c8d', class: "heading" }, this.heading), h("div", { key: 'adae3730e7602d81db333d9dce73b18ac2b9ecb2', class: "row" }, this.getSplitTableData().map(col => (h("div", { class: "column" }, h("table", null, this.headers &&
            h("tr", null, this.headers.split(', ').map(header => (h("th", null, header)))), col.map(row => (h("tr", null, h("td", null, row.name), h("td", { innerHTML: row.value.join(', ') })))))))))));
    }
    static get is() { return "vx-table"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-table.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-table.css"]
        };
    }
    static get properties() {
        return {
            "heading": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Section heading."
                },
                "attribute": "heading",
                "reflect": false
            },
            "columns": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Display table in x columns.\nValue must be >= 1."
                },
                "attribute": "columns",
                "reflect": false,
                "defaultValue": "2"
            },
            "headers": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Table headings."
                },
                "attribute": "headers",
                "reflect": false
            },
            "data": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "{\n            name: string,\n            value: string[],\n        }[]",
                    "resolved": "{ name: string; value: string[]; }[]",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Table data."
                },
                "defaultValue": "[]"
            }
        };
    }
}
//# sourceMappingURL=vx-table.js.map
